var bookshelf = require("../index-extended"); // ???: ..
require("./Agency");

module.exports = bookshelf.model("Licence", {
  tableName: "licence",
  agency() {
    return this.belongsTo("Agency");
  },
});
